import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=16a43ec6"
import script from "./Sections.vue?vue&type=script&lang=js"
export * from "./Sections.vue?vue&type=script&lang=js"
import style0 from "./Sections.vue?vue&type=style&index=0&id=16a43ec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports